import { createGlobalState } from '@vueuse/core';
import { ref, nextTick } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { HTTP_INTERNAL_SERVER_ERROR, HTTP_NOT_FOUND } from '~/support/HttpStatuses';
import { adminTeamMigrationsClient } from '~/services';

export const useMigrationDetails = createGlobalState(() => {
    const toasted = useToasted();

    const migration = ref({});
    const loading = ref(true);

    const catchRequestError = (error) => {
        console.error(error);
        if (
            !error?.response?.status ||
            error?.response?.status >= HTTP_INTERNAL_SERVER_ERROR ||
            error?.response.status == HTTP_NOT_FOUND
        ) {
            toasted?.global.platform_error();
        } else {
            toasted?.error(error.response?.data?.message || 'Something went wrong.');
        }
    };

    let onMountedMigrationCallback = () => {};
    const onMountedMigration = (callback) => {
        onMountedMigrationCallback = callback;
    };

    const mount = async (migrationId) => {
        await nextTick();

        if (!migrationId) {
            migration.value = {};
            loading.value = false;
            onMountedMigrationCallback?.();
            return;
        }

        try {
            migration.value.id = migrationId;
            loading.value = true;

            const response = await adminTeamMigrationsClient.showMigration(migrationId);
            migration.value = response.data;
            loading.value = false;
            onMountedMigrationCallback?.();
        } catch (e) {
            catchRequestError(e);
            loading.value = false;
        }
    };

    const unmount = () => {
        migration.value = {};
        loading.value = false;
    };

    const refreshMigration = async (migrationId) => {
        try {
            const response = await adminTeamMigrationsClient.showMigration(migrationId);
            migration.value = response.data;
        } catch (e) {
            console.error(e);
        }
    };

    return {
        migration,
        loading,
        mount,
        unmount,
        refreshMigration,
        onMountedMigration,
    };
});
